import Config from "../../../config";
import {allShowerSideOptionsGroups} from "../core/constants";

export const changeToClickFeatureAccordingCurrentPosition = (toClickFeature) => {
  if (!toClickFeature) {
    return toClickFeature  
  }
  if (toClickFeature.getParent) {
    const featureGroup = toClickFeature.getParent();
    if (!allShowerSideOptionsGroups.includes(toClickFeature.partId)) {
      return toClickFeature
    }
    if (featureGroup.layerPositions && toClickFeature.metaData.layerPosition
      && Object.values(featureGroup.layerPositions).filter(pos => pos).length === 1) {
      const existingPosition = Object.keys(featureGroup.layerPositions).find(pos => featureGroup.layerPositions[pos]);
      if (existingPosition !== toClickFeature.metaData.layerPosition) {
        const matchingSideFeature = featureGroup.getMatchingPositionFeature(existingPosition, toClickFeature);
        if (matchingSideFeature) {
          if (Config.isDevMode()) {
            console.log("replaced toClickFeature!", matchingSideFeature);
          }
          return matchingSideFeature
        }
      }
    }
  }
  return toClickFeature
}
